/* eslint-disable prettier/prettier */
import React from "react";

const Bell = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_502_735)">
      <circle cx="28" cy="28" r="20" fill="white" />
    </g>
    <path
      d="M35.125 34H34.5625V26.0312C34.5625 22.7242 32.118 19.9914 28.9375 19.5367V18.625C28.9375 18.107 28.518 17.6875 28 17.6875C27.482 17.6875 27.0625 18.107 27.0625 18.625V19.5367C23.882 19.9914 21.4375 22.7242 21.4375 26.0312V34H20.875C20.4602 34 20.125 34.3352 20.125 34.75V35.5C20.125 35.6031 20.2094 35.6875 20.3125 35.6875H25.375C25.375 37.1359 26.5516 38.3125 28 38.3125C29.4484 38.3125 30.625 37.1359 30.625 35.6875H35.6875C35.7906 35.6875 35.875 35.6031 35.875 35.5V34.75C35.875 34.3352 35.5398 34 35.125 34ZM28 36.8125C27.3789 36.8125 26.875 36.3086 26.875 35.6875H29.125C29.125 36.3086 28.6211 36.8125 28 36.8125ZM23.125 34V26.0312C23.125 24.7281 23.6312 23.5047 24.5523 22.5836C25.4734 21.6625 26.6969 21.1562 28 21.1562C29.3031 21.1562 30.5266 21.6625 31.4477 22.5836C32.3687 23.5047 32.875 24.7281 32.875 26.0312V34H23.125Z"
      fill="#1A1B1B"
    />
    <defs>
      <filter
        id="filter0_d_502_735"
        x="0"
        y="0"
        width="56"
        height="56"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_502_735"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_502_735"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default Bell;
